export default "__VITE_ASSET__CEL5Gjeg__"